/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { ROUTES } from '../../../constants/routes';
import { generateUrl } from '../../../routes/util';
import { UniversalTrackerPlain } from '../../../types/universalTracker';
import { useGetCarbonCalculatorsListByUtrCode } from '../../../apps/carbon-calculator/hooks';

export interface QuestionRecommendationsProps {
  utr?: Pick<UniversalTrackerPlain, 'code'>,
}

export const QuestionRecommendations = ({ utr }: QuestionRecommendationsProps) => {
  const calculatorsList = useGetCarbonCalculatorsListByUtrCode(utr?.code);

  if (calculatorsList.length === 0) {
    return null;
  }

  const onClick = () => window.open(generateUrl(ROUTES.EMISSIONS_CALCULATORS));

  return (
    <div className='text-right mt-4 mb-4'>
      <Button color='link' onClick={onClick}>Recommended emissions calculation companies</Button>
    </div>
  );
}
